appSocial.service('SocialUserService', ['SocialUser', 'SocialAPIService', function (SocialUser, SocialAPIService) {
    class SocialUserService {
        constructor() {
            /**
             * @type {SocialAPIService}
             */
            this.api = SocialAPIService;
            /**
             * @type {SocialUser}
             */
            this.user = undefined;

            /**
             * @type {TradingAccount}
             */
            this.activeTradingAccount = undefined;
        }

        /**
         * @return {SocialUser}
         */
        get() {
            return this.user;
        }

        login(token, traderId) {
            this.user = new SocialUser();
            this.user.login(token, traderId);
        }

        logout() {
            this.activeTradingAccount = undefined;
            this.user = new SocialUser();
        }

        updatePortfolio() {
            return this.api.request.getPortfolio('/' + this.user.id)
                .then((response) => {
                    this.user.init(response.trader);
                });
        }
    }

    return new SocialUserService();
}])
